// extracted by mini-css-extract-plugin
export var actions = "_9f-8";
export var arrow = "_9f-5";
export var card = "_9f-0";
export var cardWrapper = "_9f-9";
export var fieldName = "_9f-3";
export var newValue = "_9f-6";
export var oldValue = "_9f-4";
export var orangeGlowFade = "_9f-c";
export var productSection = "_9f-1";
export var scrollToBottom = "_9f-b";
export var scrollToBottomAnchor = "_9f-a";
export var scrollToBottomIcon = "_9f-d";
export var showAllButton = "_9f-7";
export var table = "_9f-2";